document.addEventListener('DOMContentLoaded', function () {
  const block = document.querySelector('#variant-video-block');
  if (!block) return;

  const videoEl = block.querySelector('#variant-video');
  if (!videoEl) return;
 
  // Toujours muet
  videoEl.muted = true;
  videoEl.volume = 0;

  // Si l'utilisateur essaie d'activer le son, on le remet en muet
  videoEl.addEventListener('volumechange', () => {
    if (!videoEl.muted || videoEl.volume !== 0) {
      videoEl.muted = true;
      videoEl.volume = 0;
    }
  });

  let variantVideos = [];
  let productVideo = null;

  // ----- RÉCUP DES DONNÉES ----- //
  try {
    if (block.dataset.variantVideos) {
      variantVideos = JSON.parse(block.dataset.variantVideos);
    }
  } catch (e) {
    console.warn('Erreur parsing variant_videos JSON', e);
  }

  if (block.dataset.productVideo && block.dataset.productVideo !== 'null' && block.dataset.productVideo !== '') {
    productVideo = block.dataset.productVideo;
  }

  console.log('Variant videos map:', variantVideos);
  console.log('Product video URL:', productVideo);

  const getVideoForVariant = (variantId) => {
    if (!variantId) return productVideo || null;

    const match = variantVideos.find((v) => {
      return String(v.id) === String(variantId) && v.url;
    });

    if (match && match.url) {
      return match.url;
    }

    return productVideo || null;
  };

   const updateVideo = (variantId) => {
    const newUrl = getVideoForVariant(variantId);

    if (!newUrl) {
      console.log('[VIDEO] Aucune vidéo pour cette variante, nettoyage');
      videoEl.removeAttribute('src');
      videoEl.load();
      return;
    }

    if (videoEl.getAttribute('src') === newUrl) {
      return;
    }

    console.log('[VIDEO] Mise à jour vidéo pour variante', variantId, '→', newUrl);

    videoEl.setAttribute('src', newUrl);
    videoEl.load();

    // On s'assure qu'elle reste toujours muette
    videoEl.muted = true;
    videoEl.volume = 0;

    videoEl.play().catch(() => {});
  };

  // ----- UTILITAIRES POUR RÉCUPÉRER L’ID VARIANTE ----- //
  const getVariantInput = () => {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (const form of forms) {
      const input = form.querySelector('input[name="id"], select[name="id"]');
      if (input) return input;
    }
    return null;
  };

  const getVariantIdFromUrl = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const v = params.get('variant');
      if (v) return v;
    } catch (e) {}
    return null;
  };

  const getCurrentVariantId = () => {
    // 1) priorité à l’URL (Tinker met souvent ?variant=... à jour)
    const fromUrl = getVariantIdFromUrl();
    if (fromUrl) return fromUrl;

    // 2) sinon on lit l’input caché
    const input = getVariantInput();
    return input ? input.value : null;
  };

  // ----- 1) EVENTS THÉORIQUES ----- //
  const attachEvents = () => {
    const input = getVariantInput();
    if (input) {
      input.addEventListener('change', (event) => {
        const variantId = event.target.value;
        console.log('[VIDEO] Variant change via event change, id =', variantId);
        updateVideo(variantId);
      });

      if (input.value) {
        updateVideo(input.value);
      }
    }

    document.addEventListener('variant:change', (event) => {
      const detail = event.detail || {};
      console.log('[VIDEO] variant:change event', detail);
      if (detail.variant && detail.variant.id) {
        updateVideo(detail.variant.id);
      }
    });
  };

  attachEvents();

  // ----- 2) POLLING DE SÉCURITÉ ----- //
  let lastVariantId = getCurrentVariantId();
  if (lastVariantId) {
    console.log('[VIDEO] Variante initiale détectée =', lastVariantId);
    updateVideo(lastVariantId);
  }

  setInterval(() => {
    const currentId = getCurrentVariantId();
    if (!currentId) return;

    if (currentId !== lastVariantId) {
      console.log('[VIDEO] Variant détecté via polling, id =', currentId, '(ancien =', lastVariantId, ')');
      lastVariantId = currentId;
      updateVideo(currentId);
    }
  }, 500); // toutes les 500ms
});
